export const resetState = (state, initialState) => {
	Object.keys(state).forEach(k => {
		state[k] = initialState[k];
	});
};
